import React from "react";
import "../styles.css";
import ContainerBody from "../components/ContainerBody";
import ButtonLink from "../components/ButtonLink";
import ContainerNav from "../components/ContainerNav";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ContainerRoot from "../components/ContainerRoot";

export default function HardPrompts(props) {
  const handleInputChange = (key, value) => {
    props.setHardPrompts({ ...props.hardPrompts, [key]: value });
  };

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>Parameters</Typography>
        <Typography>These prompts will be hardcoded!</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography>Added prompt</Typography>
            <TextField
              placeholder="Added prompt"
              defaultValue={props.hardPrompts.a_prompt}
              size="small"
              fullWidth
              multiline
              rows={4}
              onChange={(event) =>
                handleInputChange("a_prompt", event.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>Negative prompt</Typography>
            <TextField
              placeholder="Negative prompt"
              defaultValue={props.hardPrompts.n_prompt}
              size="small"
              fullWidth
              multiline
              rows={4}
              onChange={(event) =>
                handleInputChange("n_prompt", event.target.value)
              }
            />
          </Grid>
        </Grid>
      </ContainerBody>
      <ContainerNav>
        <ButtonLink url="/parameters" title="Back" />
        <ButtonLink url="/prompt" title="Add Prompt" color="primary" />
      </ContainerNav>
    </ContainerRoot>
  );
}
